module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.visible),
      expression: "visible"
    }],
    staticClass: "modal"
  }, [_c('div', {
    staticClass: "modal__wrap"
  }, [_c('div', {
    staticClass: "modal__header"
  }, [_c('h2', {
    staticClass: "modal__title"
  }, [_vm._v(_vm._s(_vm.opts.title))])]), _vm._v(" "), _c('div', {
    staticClass: "modal__body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.opts.text)
    }
  }), _vm._v(" "), _c('loader', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opts.showLoader),
      expression: "opts.showLoader"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opts.cancelButton),
      expression: "opts.cancelButton"
    }],
    staticClass: "btn btn--inline btn--white",
    on: {
      "click": function($event) {
        return _vm.cancel()
      }
    }
  }, [_vm._v(_vm._s(_vm.opts.cancelButtonText))]), _vm._v(" "), _c('button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.opts.okButton),
      expression: "opts.okButton"
    }],
    ref: "ok",
    staticClass: "btn btn--inline btn--purple",
    on: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v(_vm._s(_vm.opts.okButtonText))])])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-028afd74","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modal.vue
// module id = 680
// module chunks = 1